export const visit = (vm, at) => {
at({ "pl": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} z {{totalBytes}}" }, "fileSizeLimit": "Ten plik nie mo\u017Cesz by\u0107 wi\u0119kszy ni\u017C {{size}}", "screenCapture": "Zrzut ekranu" } } });
};